import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import ChatContainer from "../ChatContainer";
import { initializeChat } from "../features/ChatBarActions";
import { withChatContext } from "../Context";

class ChatBox extends Component {
  constructor(props) {
    super(props);

    if (this.props.initialConfig) {
      this.props.initializeChat(this.props.initialConfig, this.props.parcelCode, this.props.caseId);
    }
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "chat-box"
    }, /*#__PURE__*/React.createElement(ChatContainer, {
      show: true,
      businessUnit: this.props.config.businessUnit,
      isDragable: false,
      customizations: this.props?.customizations,
      onMinimizeClick: this.props.hideChat,
      ratingEnabled: this.props.ratingEnabled
    }));
  }

}

ChatBox.propTypes = {
  config: PropTypes.object,
  initialConfig: PropTypes.object,
  initializeChat: PropTypes.func,
  hideChat: PropTypes.func,
  customizations: PropTypes.object,
  ratingEnabled: PropTypes.bool,
  parcelCode: PropTypes.string,
  caseId: PropTypes.string
};

const mapStateToProps = state => ({
  config: state.chat.config
});

const mapDispatchToProps = (dispatch, {
  apiClient
}) => ({
  initializeChat: (config, parcelCode, caseId) => dispatch(initializeChat(config, apiClient.chatConfig.businessUnit, {
    parcelCode,
    caseId
  }))
});

export default compose(withChatContext, connect(mapStateToProps, mapDispatchToProps))(ChatBox);